// extracted by mini-css-extract-plugin
module.exports = {"container":"nb","disabled":"ob","option":"pb","submit":"qb","success":"rb","failure":"sb"};